exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-list-move[data-v-5348b37c]{-webkit-transition:-webkit-transform .5s;transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.drag-handle[data-v-5348b37c]{cursor:move}.v-card[data-v-5348b37c]{-webkit-transition:all .3s;transition:all .3s}", ""]);

// exports
